import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { format } from 'date-fns';
import { attendanceSheetDayEnumInFull } from '../../enums/attendance-sheet-day.enum';
import { AttendanceSheetDayHistoryDto } from '@/api.types';

interface IMyProps {
  dia: number
  historicos?: AttendanceSheetDayHistoryDto[];
  show: boolean;
  handleHide: () => void;
}

export default function ModalHistoricoDiaFolha({ dia, historicos, show, handleHide }: IMyProps) {

  if (!show)
    return;

  return (
    <Modal show={show} onHide={handleHide} centered >
      <Modal.Header closeButton>
        <Modal.Title >
          Dia {dia} - Histórico de Edições
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <table className="table table-sm table-striped table-hover">
          <thead>
            <tr>
              <th>Data</th>
              <th>Entrada</th>
              <th>Saída</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody className="table-group-divider">
            {historicos && historicos
              .sort((a, b) => new Date(b.criadoEm).getTime() - new Date(a.criadoEm).getTime())
              .map((historico, index) => {
                return <tr key={index}>
                  <th scope="row">
                    {format(new Date(historico.criadoEm), 'dd/MM/yyyy HH:mm')}
                  </th>
                  <td>
                    {historico.diff.horario_entrada ? String(historico.diff.horario_entrada) : ''}
                  </td>
                  <td>
                    {historico.diff.horario_saida ? String(historico.diff.horario_saida) : ''}
                  </td>
                  <td>
                    {historico.diff.status ? attendanceSheetDayEnumInFull(historico.diff.status) : ''}
                  </td>
                </tr>
              })}
          </tbody>
        </table>
      </Modal.Body>
      <Modal.Footer className="text-left">
        <Button variant="secondary" onClick={handleHide}>
          Fechar
        </Button>
      </Modal.Footer>
    </Modal>
  );
}